<template>
  <div id="netBillingMetricReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Net Billing Metrics for Period</div>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportReports()">
                        <i class="fp-export"></i> Export
                    </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'netBillingMetricReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'netBillingMetricReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Net Billing Metric Report"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "NetBillingMetricsPeriod",
  metaInfo() {
            return {title: "Net Billing Metrics for Period Report | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    firstLoad: 0,
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: "Record Status Unit",
          field: "unit_status",
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "All", // placeholder for filter input
            filterDropdownItems: ['A','S','V','I'], // dropdown (with selected values) instead of text input
            filterValue: " ", // initial populated value for this filter
            trigger: "enter" //only trigger on enter not on keyup
          }
      },
      {
          label: 'Purchase Date',
          field: 'purchase_date',
          filterable: true,
          fpFieldType:"date",
          hidden:false,
      },
      {
          label: 'Gross Weight',
          field: 'gross_weight',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Tare Weight',
          field: 'tare_weight',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Date In Service',
          field: 'date_in_service',
          filterable: true,
          fpFieldType:"date",
          hidden:false,
      },
      {
          label: 'Unit Year',
          field: 'year',
          fpFieldType:"integer",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Unit Ownership',
          field: 'owner',
          fpFieldType:"option",
          hidden: false,
          filterable: true,
      },
      {
          label: 'Unit Description',
          field: 'unit_desc',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
      },
      {
          label: 'Equipment Group Code',
          field: 'equip_grp',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Manufacturer Code Unit',
          field: 'manufacturer_code',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Model Code Unit',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Equipment Type Unit',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Weight UOM Code',
          field: 'uom',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Beginning Reading',
          field: 'read_begin',
          fpFieldType:"text",
          hidden:false,
          // type:'number',
          filterable: false,
          sortable:false,
      },
      {
          label: 'Beginning Date',
          field: 'date_begin',
          filterable: false,
          fpFieldType:"date",
          hidden:false,
          sortable:false,
      },
      {
          label: 'End Reading',
          field: 'read_end',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable:false,
      },
      {
          label: 'End Reading Date',
          field: 'date_end',
          filterable: false,
          fpFieldType:"date",
          hidden:false,
          sortable:false,
      },
      {
          label: "Actual Estimate",
          field: "actual_estimate",
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "estimate", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ['A','E'], // dropdown (with selected values) instead of text input
            trigger: "enter" //only trigger on enter not on keyup
          }
      },
       {
            label: "Billed",
            field: "billed",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterValue: "", // initial populated value for this filter
              filterDropdownItems: ['B','I'], // dropdown (with selected values) instead of text input
              trigger: "enter" //only trigger on enter not on keyup
            },
            sortable:false
        },
         {
            label: 'Metric Type',
            field: 'section',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            width:'90px',
        },
        {
            label: "Distance Traveled",
            field: "dist_travelled",
            fpFieldType:"text",
            hidden:false,
            // type:'number',
            filterable: false,
        },
        {
            label: "Reading LTD",
            field: "ltd_reading",
            fpFieldType:"integer",
            hidden:false,
            // type:'number',
            filterable: true,
        },
        {
            label: "Meter Change",
            field: "meter_change",
            filterable: true,
            fpFieldType:"option",
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "meter change", // placeholder for filter input
                filterValue: '', // initial populated value for this filter
                filterDropdownItems: ['Y','N'], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
          label: 'Agreement Header Type',
          field: 'agreement_type',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['RC','LC'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false,
        },
        {
          label: 'Agreement Number',
          field: 'agreement_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
        },
        {
            label: "Unit Assignment Date",
            field: "unit_assignement_date",
            filterable: true,
            fpFieldType:"date",
            hidden:false,
        },
        {
            label: "Facility ID Code",
            field: 'location',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
        },
        {
            label: "Customer Company Code",
            field: "company_code",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer Number",
            field: "customer_number",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer Suffix",
            field: "customer_suffix",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
            label: "Customer Name",
            field: "customer_name",
            filterable: true,
            fpFieldType:"text",
            hidden:false,
        },
        {
          label: 'Contract Equip Sts',
          field: 'contract_status',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Active','Billed','Closed','Pending'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
        },
        {
          label: "Reading From Date",
          field: "start_date",
          filterable: false,
          fpFieldType:"date",
          hidden:true,
          sortable: false,
        },
        {
          label: "Reading To Date",
          field: "end_date",
          filterable: false,
          fpFieldType:"date",
          hidden:true,
          sortable: false,
        },
    ],
    batchProcess:0,
    batchNum:"",




  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'net_billing_metrics_for_period') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{

    // exportReports: function() {
    //             this.action = "export";
    //             this.loadList();
    //         },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/net-billing-metrics-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action


        },
        success: function(data) {
          self.loading = false;
          // console.log(data.content.row);
          if (data.status == "success") {
            if (self.action == "export" ||  self.action == "export_queue") {
                if ( data.code == "201" ) {
                    alert(data.message);
                } else {
                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }
                }

              self.action = "list";
              // self.loadList();
          } else {

              console.log('success');

              if (data.content.row != undefined) {

                console.log("data.content.log");
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;

          }
        }
      },
      error: function(jqXHR, exception) {
        self.loading = false;
          self.generateStatusCodeMessage(jqXHR,true,'net-billing-metrics-report');
      }
    });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/NetBillingMetricsReport.vue